import { render, staticRenderFns } from "./user-bio-1.vue?vue&type=template&id=4d4b9920&scoped=true"
import script from "./user-bio-1.vue?vue&type=script&lang=js"
export * from "./user-bio-1.vue?vue&type=script&lang=js"
import style0 from "./user-bio-1.vue?vue&type=style&index=0&id=4d4b9920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b9920",
  null
  
)

export default component.exports